import { CITY } from '@city'

/** The city site's own host and its `www.` alias — London `london-tube.com`, New York `newyork-subway.com`. */
const PRODUCTION_HOSTS = [CITY.domain, `www.${CITY.domain}`]

/**
 * Single source of truth for "is this a real production browser session?".
 *
 * Both the analytics loaders (`cookie/consent.ts`) and the emit gate
 * (`analytics/webAnalyticsReporter.ts`) ask this exact question, and they
 * must get the exact same answer — release-path parity, safe-client rule
 * #1: production inits the SDKs AND emits; dev, bots and localhost init
 * nothing AND emit nothing. Gating one side and not the other is the
 * canonical footgun, and it is what put a `ssr: true` Yandex Metrika
 * counter (removed in TASK-1162) in production for months.
 *
 * TASK-570: this lived in `cookie/consent.ts`, which made the reporter
 * import the consent module, which imports the event recorders, which
 * import the reporter — a three-module cycle that was baselined rather
 * than fixed. A leaf both sides can import breaks it without moving any
 * logic. The predicate is the only thing that was ever shared.
 */
export function isProductionEnvironment(): boolean {
  // SSR / prerender guard — never reachable in the jsdom test env, but
  // keeps `vite build`'s ESM tree-shaker / static-analysis happy when
  // this file is imported from a non-browser context.
  /* v8 ignore next */
  if (typeof window === 'undefined') return false
  if (PRODUCTION_HOSTS.indexOf(window.location.hostname) === -1) return false
  if (window.navigator.webdriver === true) return false
  if (
    /HeadlessChrome|Lighthouse|PTST|WebPageTest|GTmetrix|bot|crawler|spider/i.test(
      window.navigator.userAgent,
    )
  ) {
    return false
  }
  return true
}
